import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  private dataQrCode = new BehaviorSubject('');
  currentDataQrCode = this.dataQrCode.asObservable();

  private data = new BehaviorSubject('');
  currentData = this.data.asObservable();

  private dataImm = new BehaviorSubject('');
  currentDataImm = this.dataImm.asObservable();

  private dataCheckPers = new BehaviorSubject('');
  currentDataCheckPers = this.dataCheckPers.asObservable();

  private dataClient = new BehaviorSubject('');
  currentDataClient = this.dataClient.asObservable();

  private dataChechPersAbon = new BehaviorSubject('');
  currentDataChechPersAbon = this.dataChechPersAbon.asObservable();

  private dataFermerHamburger = new BehaviorSubject('');
  currentDataFermerHamburger = this.dataFermerHamburger.asObservable();

  private dataFermerKiosque = new BehaviorSubject('');
  currentDataFermerKiosque = this.dataFermerKiosque.asObservable();

  private dataHeaderKiosque = new BehaviorSubject('');
  currentDataHeaderKiosque = this.dataHeaderKiosque.asObservable();

  private dataModifierKiosque = new BehaviorSubject('');
  currentDataModifierKiosque = this.dataModifierKiosque.asObservable();

  public infoKiosque : any = {};
  public infoImmeuble : any = {};
  public infoHeader : any = {}; 
  public infoModifier : any = {};

  constructor(private router : Router,  private route: ActivatedRoute,) { }

  public sendInformationQrCode(item: any) {
    this.dataQrCode.next(item);
  }

  public sendInformationKiosque(item: any) {
    this.dataFermerKiosque.next(item);
  } 

  public sendInformationModifier(item: any) {
    this.dataModifierKiosque.next(item);
  } 

  public sendInformationHeader(item: any) {
    this.dataHeaderKiosque.next(item);
  } 

  public sendInformation(item: any) {
    this.data.next(item);
  }

  public sendInformationDataImm(item: any) {
    this.dataImm.next(item);
  }

  public sendInformationDataCheckPers(item: any) {
    this.dataCheckPers.next(item);
  }

  public sendInformationDataClient(item: any) {
    this.dataClient.next(item);
  }

  public sendInformationDataChechPersAbon(item: any) {
    this.dataChechPersAbon.next(item);
  }

  public sendInformationDataFermerHamburger(item: any) {
    this.dataFermerHamburger.next(item);
  } 

  public setImm(infoImm?: any) {
    this.infoImmeuble = infoImm;
    sessionStorage.setItem('xyz-token', JSON.stringify(infoImm));
    return this.infoImmeuble;
  }

  public getImm(): any {
    const info = JSON.parse(sessionStorage.getItem('xyz-token') || '{}');
    return info;
  }

  public noEspaceInput(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }


}